import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { S11Exchange } from '../../store/auth/auth.actions';
import { AuthGuard } from './auth.guard';

@Injectable({ providedIn: 'root' })
export class S11ExchangeGuard {
  constructor(
    private router: Router,
    private store: Store,
    private authGuard: AuthGuard,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | boolean {
    const code = route.queryParamMap.get('code');
    if (!code) {
      return this.authGuard.canActivate(route, state);
    }

    return this.store.dispatch(new S11Exchange(code)).pipe(
      map(() => this.router.createUrlTree(['/memos'])),
      catchError(() => of(this.router.parseUrl('/login'))),
    );
  }
}
